import { TranslationKeys } from '~frontend-common/i18n/english/cars-driver-assignments-subquestions.i18n';

const keys: TranslationKeys = {
  driverAssignment: {
    subtitle: 'Un conducteur principal est requis',
  },
};

export default keys;
